export function addWindowEventListener<T extends keyof WindowEventMap>(
  eventName: T,
  handler: (event: WindowEventMap[T]) => void,
) {
  const controller: AbortController = new AbortController();
  window.addEventListener(eventName, handler, { signal: controller.signal });

  return () => {
    controller.abort();
  };
}
